import { Injectable } from '@angular/core';
import { DriverDto, DriversApiService } from '@fleet-beat/api';
import { BaseDataSourceServiceV2, GetManyV2Dto, PageableListV2Dto, SnackbarService } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DriverListAutocompleteStorageService extends BaseDataSourceServiceV2<
  DriverDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private driversApiService: DriversApiService,
    private companyStoreService: CompanyStoreService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{
      input: string;
      include?: string;
      driverId?: BehaviorSubject<string>;
      isActive?: boolean;
      offset?: number;
      limit?: number;
    }>,
  ): Observable<PageableListV2Dto<DriverDto>> {
    const driverId: string = data.extra.driverId?.getValue();

    const {
      isActive,
      offset,
      limit,
      include,
    }: { isActive?: boolean; offset?: number; limit?: number; include?: string } = data.extra;

    const params: GetManyV2Dto = {
      search: data.params.input,
      companyIds: this.companyStoreService.companyId,
      isActive,
      offset,
      limit,
      include,
    };
    const response = this.driversApiService.getMany(params, this.authService.authHeaders);
    return response.pipe(
      map((value: PageableListV2Dto<DriverDto>) => {
        const mapResponse = value.data.filter((innerValue: DriverDto) => {
          return driverId ? innerValue.id !== driverId : true;
        });
        return { ...value, data: mapResponse };
      }),
    );
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<DriverDto> {
    throw new Error('Not Implemented');
  }
}
